import { render, staticRenderFns } from "./PublishedModelCard.vue?vue&type=template&id=1333615f&scoped=true&"
import script from "./PublishedModelCard.vue?vue&type=script&lang=js&"
export * from "./PublishedModelCard.vue?vue&type=script&lang=js&"
import style0 from "./PublishedModelCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PublishedModelCard.vue?vue&type=style&index=1&id=1333615f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1333615f",
  null
  
)

export default component.exports